// Literal array Postgres (`{A,B}`) per lo scalar `_text` di Hasura.
// I POD hanno già passato la regex del validatore `pod`, quindi non servono escape.
export function toPgTextArray(values: string[]): string {
  return `{${values.join(',')}}`;
}
